// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Existing Styles */
/* Ensuring consistent layout across browsers */
.activity-perform-button-styles,
.activity-perform-button-mobile-styles {
  font-size: 12px !important;
  font-weight: 600 !important;
  line-height: 35px !important;
  letter-spacing: -0.004em;
  text-align: center !important;
  padding: 0px 8px 0px 8px !important;
  color: #564ffd !important;
  background-color: #ebebff !important;
  border-color: #ebebff !important;
  margin-right: 10px;
}

.activity-perform-button-mobile-styles {
  font-size: 10px !important;
  font-weight: 900 !important;
  line-height: 35px !important;
  letter-spacing: -0.004em;
  text-align: center !important;
  padding: 0px 8px 0px 8px !important;
  color: #564ffd !important;
  background-color: #ebebff !important;
  border-color: #ebebff !important;
  margin-right: 5px;
}

.dashboard-view-details {
  font-size: 10px !important;
  color: #564ffd !important;
  font-weight: 900 !important;
}

.activity-perform-button-mobile-styles:hover,
.activity-perform-button-styles:hover {
  color: white !important;
  background-color: #564ffd !important;
}

.performance-title-styles {
  font-size: 16px;
  font-weight: 900 !important;
  line-height: 40px;
  letter-spacing: -0.004em;
  text-align: left !important;
}

.dashboard-performance-topic-styles {
  font-size: 12px !important;
  color: #564ffd !important;
  font-weight: 900 !important;
  margin-left: 12px;
}

.load-more-button-styles {
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  letter-spacing: -0.004em;
  text-align: center !important;
  padding: 0px 16px 0px 16px !important;
  color: #564ffd !important;
  background-color: #ebebff !important;
  border-color: #ebebff !important;
  margin-top: 40px !important;
  margin-bottom: 15px !important;
}

.load-more-button-styles:hover {
  color: white !important;
  background-color: #564ffd !important;
}

/* Media Queries for screens smaller than 408px */
@media screen and (max-width: 408px) {
  .activity-perform-button-styles,
  .activity-perform-button-mobile-styles {
    font-size: 9px !important; /* Decrease button font size */
    padding: 0px 6px 0px 6px !important; /* Adjust padding */
    line-height: 30px !important; /* Adjust line-height */
    margin-right: 5px !important; /* Adjust margin */
  }
  .performance-title-styles {
    font-size: 10px !important; /* Decrease title font size */
    line-height: 30px !important; /* Adjust line-height */
  }
  .dashboard-performance-topic-styles {
    font-size: 10px !important; /* Decrease topic font size */
    margin-left: 8px !important; /* Adjust margin */
  }
  .dashboard-view-details {
    font-size: 9px !important; /* Decrease details font size */
  }
  .load-more-button-styles {
    font-size: 14px !important; /* Decrease button font size */
    line-height: 35px !important; /* Adjust line-height */
    padding: 0px 12px 0px 12px !important; /* Adjust padding */
  }
}
/* Additional Tweaks for iOS (using webkit prefixes) */
@media screen and (max-width: 408px) {
  .activity-perform-button-styles,
  .activity-perform-button-mobile-styles {
    flex-basis: auto;
    flex-shrink: 1;
  }
  .performance-title-styles {
    flex-basis: auto;
    flex-shrink: 1;
  }
}
@media screen and (max-width: 380px) {
  .activity-perform-button-styles,
  .activity-perform-button-mobile-styles {
    font-size: 7px !important; /* Decrease button font size */
    padding: 0px 4px 0px 4px !important; /* Adjust padding */
    line-height: 25px !important; /* Adjust line-height */
    margin-right: 3px !important; /* Adjust margin */
  }
  .performance-title-styles {
    font-size: 7px !important; /* Decrease title font size */
    line-height: 25px !important; /* Adjust line-height */
  }
  .dashboard-performance-topic-styles {
    font-size: 7px !important; /* Decrease topic font size */
    margin-left: 6px !important; /* Adjust margin */
  }
  .dashboard-view-details {
    font-size: 6px !important; /* Decrease details font size */
  }
  .load-more-button-styles {
    font-size: 10px !important; /* Decrease button font size */
    line-height: 30px !important; /* Adjust line-height */
    padding: 0px 10px 0px 10px !important; /* Adjust padding */
  }
}
.score-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  transition: all 0.2s ease;
}
.score-display:hover {
  background: #f0f0f0;
  transform: translateY(-1px);
}
.score-display .score-circle {
  display: flex;
  align-items: center;
  gap: 2px;
  font-weight: 600;
  color: #564ffd;
}
.score-display .score-circle .score-value {
  font-size: 1.2rem;
  color: #2c3e50;
}
.score-display .score-circle .score-divider {
  font-size: 1.2rem;
  color: #6c757d;
}
.score-display .score-circle .score-total {
  font-size: 1.2rem;
  color: #2c3e50;
}
.score-display .score-label {
  font-size: 0.8rem;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

@media (max-width: 768px) {
  .score-display {
    padding: 6px 12px;
  }
  .score-display .score-circle .score-value,
  .score-display .score-circle .score-divider,
  .score-display .score-circle .score-total {
    font-size: 1rem;
  }
  .score-display .score-label {
    font-size: 0.7rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/StudentDashboard/ActivitesComponents/styles.scss"],"names":[],"mappings":"AAAA,cAAA;AACA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AACF;;AAEA,oBAAA;AAEA,+CAAA;AACA;;EAEE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,6BAAA;EACA,mCAAA;EACA,yBAAA;EACA,oCAAA;EACA,gCAAA;EACA,kBAAA;AAAF;;AAGA;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,6BAAA;EACA,mCAAA;EACA,yBAAA;EACA,oCAAA;EACA,gCAAA;EACA,iBAAA;AAAF;;AAGA;EACE,0BAAA;EACA,yBAAA;EACA,2BAAA;AAAF;;AAGA;;EAEE,uBAAA;EACA,oCAAA;AAAF;;AAGA;EACE,eAAA;EACA,2BAAA;EACA,iBAAA;EACA,wBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,0BAAA;EACA,yBAAA;EACA,2BAAA;EACA,iBAAA;AAAF;;AAGA;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,6BAAA;EACA,qCAAA;EACA,yBAAA;EACA,oCAAA;EACA,gCAAA;EACA,2BAAA;EACA,8BAAA;AAAF;;AAGA;EACE,uBAAA;EACA,oCAAA;AAAF;;AAGA,iDAAA;AACA;EACE;;IAEE,yBAAA,EAAA,8BAAA;IACA,mCAAA,EAAA,mBAAA;IACA,4BAAA,EAAA,uBAAA;IACA,4BAAA,EAAA,kBAAA;EAAF;EAGA;IACE,0BAAA,EAAA,6BAAA;IACA,4BAAA,EAAA,uBAAA;EADF;EAIA;IACE,0BAAA,EAAA,6BAAA;IACA,2BAAA,EAAA,kBAAA;EAFF;EAKA;IACE,yBAAA,EAAA,+BAAA;EAHF;EAMA;IACE,0BAAA,EAAA,8BAAA;IACA,4BAAA,EAAA,uBAAA;IACA,qCAAA,EAAA,mBAAA;EAJF;AACF;AAOA,sDAAA;AACA;EACE;;IAGE,gBAAA;IAEA,cAAA;EALF;EAQA;IAEE,gBAAA;IAEA,cAAA;EANF;AACF;AASA;EACE;;IAEE,yBAAA,EAAA,8BAAA;IACA,mCAAA,EAAA,mBAAA;IACA,4BAAA,EAAA,uBAAA;IACA,4BAAA,EAAA,kBAAA;EAPF;EAUA;IACE,yBAAA,EAAA,6BAAA;IACA,4BAAA,EAAA,uBAAA;EARF;EAWA;IACE,yBAAA,EAAA,6BAAA;IACA,2BAAA,EAAA,kBAAA;EATF;EAYA;IACE,yBAAA,EAAA,+BAAA;EAVF;EAaA;IACE,0BAAA,EAAA,8BAAA;IACA,4BAAA,EAAA,uBAAA;IACA,qCAAA,EAAA,mBAAA;EAXF;AACF;AAcA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;AAZF;AAcE;EACE,mBAAA;EACA,2BAAA;AAZJ;AAeE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;AAbJ;AAeI;EACE,iBAAA;EACA,cAAA;AAbN;AAgBI;EACE,iBAAA;EACA,cAAA;AAdN;AAiBI;EACE,iBAAA;EACA,cAAA;AAfN;AAmBE;EACE,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AAjBJ;;AAqBA;EACE;IACE,iBAAA;EAlBF;EAqBI;;;IAGE,eAAA;EAnBN;EAuBE;IACE,iBAAA;EArBJ;AACF","sourcesContent":["/* CSS Reset */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Existing Styles */\n\n/* Ensuring consistent layout across browsers */\n.activity-perform-button-styles,\n.activity-perform-button-mobile-styles {\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  line-height: 35px !important;\n  letter-spacing: -0.004em;\n  text-align: center !important;\n  padding: 0px 8px 0px 8px !important;\n  color: #564ffd !important;\n  background-color: #ebebff !important;\n  border-color: #ebebff !important;\n  margin-right: 10px;\n}\n\n.activity-perform-button-mobile-styles {\n  font-size: 10px !important;\n  font-weight: 900 !important;\n  line-height: 35px !important;\n  letter-spacing: -0.004em;\n  text-align: center !important;\n  padding: 0px 8px 0px 8px !important;\n  color: #564ffd !important;\n  background-color: #ebebff !important;\n  border-color: #ebebff !important;\n  margin-right: 5px;\n}\n\n.dashboard-view-details {\n  font-size: 10px !important;\n  color: #564ffd !important;\n  font-weight: 900 !important;\n}\n\n.activity-perform-button-mobile-styles:hover,\n.activity-perform-button-styles:hover {\n  color: white !important;\n  background-color: #564ffd !important;\n}\n\n.performance-title-styles {\n  font-size: 16px;\n  font-weight: 900 !important;\n  line-height: 40px;\n  letter-spacing: -0.004em;\n  text-align: left !important;\n}\n\n.dashboard-performance-topic-styles {\n  font-size: 12px !important;\n  color: #564ffd !important;\n  font-weight: 900 !important;\n  margin-left: 12px;\n}\n\n.load-more-button-styles {\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  line-height: 40px !important;\n  letter-spacing: -0.004em;\n  text-align: center !important;\n  padding: 0px 16px 0px 16px !important;\n  color: #564ffd !important;\n  background-color: #ebebff !important;\n  border-color: #ebebff !important;\n  margin-top: 40px !important;\n  margin-bottom: 15px !important;\n}\n\n.load-more-button-styles:hover {\n  color: white !important;\n  background-color: #564ffd !important;\n}\n\n/* Media Queries for screens smaller than 408px */\n@media screen and (max-width: 408px) {\n  .activity-perform-button-styles,\n  .activity-perform-button-mobile-styles {\n    font-size: 9px !important; /* Decrease button font size */\n    padding: 0px 6px 0px 6px !important; /* Adjust padding */\n    line-height: 30px !important; /* Adjust line-height */\n    margin-right: 5px !important; /* Adjust margin */\n  }\n\n  .performance-title-styles {\n    font-size: 10px !important; /* Decrease title font size */\n    line-height: 30px !important; /* Adjust line-height */\n  }\n\n  .dashboard-performance-topic-styles {\n    font-size: 10px !important; /* Decrease topic font size */\n    margin-left: 8px !important; /* Adjust margin */\n  }\n\n  .dashboard-view-details {\n    font-size: 9px !important; /* Decrease details font size */\n  }\n\n  .load-more-button-styles {\n    font-size: 14px !important; /* Decrease button font size */\n    line-height: 35px !important; /* Adjust line-height */\n    padding: 0px 12px 0px 12px !important; /* Adjust padding */\n  }\n}\n\n/* Additional Tweaks for iOS (using webkit prefixes) */\n@media screen and (max-width: 408px) {\n  .activity-perform-button-styles,\n  .activity-perform-button-mobile-styles {\n    -webkit-flex-basis: auto;\n    flex-basis: auto;\n    -webkit-flex-shrink: 1;\n    flex-shrink: 1;\n  }\n\n  .performance-title-styles {\n    -webkit-flex-basis: auto;\n    flex-basis: auto;\n    -webkit-flex-shrink: 1;\n    flex-shrink: 1;\n  }\n}\n\n@media screen and (max-width: 380px) {\n  .activity-perform-button-styles,\n  .activity-perform-button-mobile-styles {\n    font-size: 7px !important; /* Decrease button font size */\n    padding: 0px 4px 0px 4px !important; /* Adjust padding */\n    line-height: 25px !important; /* Adjust line-height */\n    margin-right: 3px !important; /* Adjust margin */\n  }\n\n  .performance-title-styles {\n    font-size: 7px !important; /* Decrease title font size */\n    line-height: 25px !important; /* Adjust line-height */\n  }\n\n  .dashboard-performance-topic-styles {\n    font-size: 7px !important; /* Decrease topic font size */\n    margin-left: 6px !important; /* Adjust margin */\n  }\n\n  .dashboard-view-details {\n    font-size: 6px !important; /* Decrease details font size */\n  }\n\n  .load-more-button-styles {\n    font-size: 10px !important; /* Decrease button font size */\n    line-height: 30px !important; /* Adjust line-height */\n    padding: 0px 10px 0px 10px !important; /* Adjust padding */\n  }\n}\n\n.score-display {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 16px;\n  background: #f8f9fa;\n  border-radius: 12px;\n  border: 1px solid #e0e0e0;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #f0f0f0;\n    transform: translateY(-1px);\n  }\n\n  .score-circle {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    font-weight: 600;\n    color: #564ffd;\n\n    .score-value {\n      font-size: 1.2rem;\n      color: #2c3e50;\n    }\n\n    .score-divider {\n      font-size: 1.2rem;\n      color: #6c757d;\n    }\n\n    .score-total {\n      font-size: 1.2rem;\n      color: #2c3e50;\n    }\n  }\n\n  .score-label {\n    font-size: 0.8rem;\n    color: #6c757d;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n}\n\n@media (max-width: 768px) {\n  .score-display {\n    padding: 6px 12px;\n\n    .score-circle {\n      .score-value,\n      .score-divider,\n      .score-total {\n        font-size: 1rem;\n      }\n    }\n\n    .score-label {\n      font-size: 0.7rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
